<template>
  <section>
    <div
      id="data-row-container"
      v-for="(data, index) in abuseData"
      :key="index"
    >
      <table-row :count="data.count">
        <template v-slot:rank> {{ data.rank }} </template>
        <template v-slot:name> {{ data.name }} </template>
        <template v-slot:sport> {{ data.sport }} </template>
        <template v-slot:count>
          <div class="inner-bar" :id="data.name">
            <div class="score">{{humanFormat(data.count)}}</div>
          </div>
        </template>
      </table-row>
    </div>
  </section>
</template>


<script>
import TableRow from "@/components/TableRow";
import data from "@/assets/data/AbuseData.js";
import methods from "@/components/TableDataMethods.js";
import watchers from "@/components/TableDataWatchers.js";

export default {
  components: {
    TableRow,
  },
  props: {
    chosenCategory: String,
    orderCategory: Number,
  },
  data() {
    return {
      allData: data.abuseData,
      abuseData: [],
      sortDirection: 1,
      maxCount: 0,
      orderBy: "count",
    };
  },
  methods: {
    ...methods,
  },
  watch: {
    ...watchers,
  },
 

  beforeMount() {
    this.FilterByAbuseCategory();
    this.orderData();
  },
  async mounted() {
    this.maxCount = this.getMaxAbuseCount();
    await window.setTimeout(() => this.setCountBarLength(), 50);
  },
};
</script>

<style lang="scss" scoped>
#data-row-container {
  width: 80vw;
  max-width: 1320px;
  @include respond(desktop-sm) {
    width: 95vw;
  }
}

#image {
  width: 60px;
  position: relative;
  top: 1px;
  left: -20px;
  @include respond(phone-only) {
    display: none;
  }
}

.inner-bar {
  height: 30px;
  background-color: $red2;
  width: 1%;
  @include transition(all 1s ease-in-out);
}

.score {
  color: $white;
  margin-left: 10px;
  margin-top: 4px;
}
</style>